import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"logo-cnb"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.8141 2.92516C11.9603 2.8633 11.2761 2.93398 10.7427 3.05574L14.5336 5.99883L15.2907 3.7738C14.765 3.42156 13.9242 3.0055 12.8141 2.92516ZM14.2253 7.53477L8.65762 3.21238C8.3818 2.99832 8.39829 2.574 8.69313 2.38716C9.37663 1.95334 10.7297 1.36815 12.9153 1.52649C14.8669 1.66771 16.1667 2.62276 16.6809 3.07621C16.8343 3.21111 16.8909 3.42517 16.8249 3.61833L15.636 7.11234C15.4356 7.70007 14.716 7.91539 14.2253 7.53477Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.10012 16.4481C2.8725 16.6008 2.76978 16.882 2.84332 17.146C3.05511 17.9061 3.68599 19.4874 5.47656 20.9263C7.26714 22.3653 9.38551 22.5204 10.2909 22.4982C10.5617 22.4919 10.7976 22.314 10.8793 22.0555L14.4484 10.773C14.7059 9.95856 13.7922 9.2752 13.0827 9.75147L3.10012 16.4481ZM9.71619 21.0829C8.84223 21.0225 7.49889 20.7525 6.35499 19.8333C5.20702 18.9108 4.64418 17.9379 4.37298 17.283L12.6814 11.7093L9.71619 21.0829Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.25671 8.81605C3.85119 7.26729 4.91761 6.38899 5.54284 5.9854L11.3933 8.30299L2.92762 11.6044C2.86374 10.7633 2.90326 9.73554 3.25671 8.81605ZM5.70871 4.54275C5.53372 4.47372 5.33779 4.48512 5.17231 4.57506C4.51162 4.93414 2.81997 6.04054 1.94751 8.31352C1.27414 10.0653 1.51128 12.0026 1.69642 12.95C1.75729 13.2597 2.08446 13.4383 2.37867 13.3237L13.0872 9.1476C13.8519 8.84931 13.8551 7.7695 13.0917 7.46742L5.70871 4.54275Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.594 12.627C21.9033 12.8366 22.3269 12.6517 22.3807 12.2818C22.5228 11.3027 22.6458 9.59847 22.0783 8.31283C21.3219 6.59971 20.038 5.54334 19.4286 5.11395C19.2358 4.97842 18.9759 4.99236 18.799 5.14878L16.0966 7.54272C15.6553 7.93348 15.7011 8.63455 16.1892 8.96578L21.594 12.627ZM20.7955 8.87928C21.0087 9.3624 21.0895 9.98007 21.097 10.5965L17.5084 8.16558L19.1685 6.69498M19.1685 6.69498C19.6963 7.1614 20.359 7.8909 20.7955 8.87928L19.1685 6.69498Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.5419 20.727L16.3195 11.8863L20.0284 16.4584C19.8372 17.1346 19.3782 18.2892 18.3397 19.2798C17.4966 20.0844 16.4287 20.5075 15.5419 20.727ZM14.0426 21.766V21.7741C14.0408 21.7993 14.0408 21.8241 14.0426 21.8485L14.0432 21.8563C14.0678 22.1326 14.3161 22.3449 14.6037 22.314C15.6277 22.2045 17.7315 21.7984 19.3078 20.2944C20.8422 18.8307 21.3412 17.0929 21.4864 16.4013C21.5257 16.2145 21.4788 16.0201 21.3583 15.8719L16.6333 10.0473C16.1217 9.41649 15.1015 9.72807 15.0304 10.5368L14.0426 21.766Z"}}]}]};

const LogoCnb = Vue.extend<IconProps>({
  name: 'LogoCnbIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-cnb',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoCnb;
